<template>
  <div
    class="app-content content"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  >
    <div class="content-overlay flex">
      <div class="text">
        {{ $store.state.app.overlayText }}
      </div>
      <b-spinner
        label="Spinning"
        :type="$store.state.app.overlayType"
        :variant="$store.state.app.overlayVariant"
      />
    </div>
    <div class="header-navbar-shadow" />
    <transition
      :name="routerTransition"
      mode="out-in"
    >
      <div
        class="content-wrapper clearfix"
        :class="contentWidth === 'boxed' ? 'container p-0' : null"
      >
        <slot name="breadcrumb">
          <app-breadcrumb />
        </slot>
        <div class="content-detached content-right">
          <div class="content-wrapper">
            <div class="content-body">
              <slot />
            </div>
          </div>
        </div>
        <portal-target
          name="content-renderer-sidebar-detached-left"
          slim
        />
      </div>
    </transition>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { BSpinner } from 'bootstrap-vue'

export default {
  components: {
    AppBreadcrumb,
    BSpinner,
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
}
</script>

<style>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.text {
  font-size: 2rem;
  font-weight: bolder;
  color: white;
}
</style>
